import React from "react";
const Profile = React.lazy(() => import('./Profile'));

export const profilePageConfig = [
    {
        path: '/profile',
        element: <Profile />
    },

];